import styled from "styled-components";

export const Container = styled.div`
  padding-left: ${({ theme }) =>
    theme.layout.content.paddingHorizontal.desktop}px;
  padding-right: ${({ theme }) =>
    theme.layout.content.paddingHorizontal.desktop}px;
  padding-top: 100px;
  padding-bottom: 100px;

  @media only screen and (max-width: 768px) {
    padding-top: 53px;
    padding-bottom: 53px;
  }

  @media only screen and (max-width: 560px) {
    padding-right: 38px;
    padding-left: 38px;
  }

  @media only screen and (max-width: 475px) {
    padding-left: ${({ theme }) =>
      theme.layout.content.paddingHorizontal.mobile}px;
    padding-right: ${({ theme }) =>
      theme.layout.content.paddingHorizontal.mobile}px;
  }
`;
